import { createRouter, createWebHashHistory } from 'vue-router'
import { useApi } from '@/stores/apiTemplate'
import Auth from '@/views/Auth.vue'
import Base from '@/components/Base.vue'
import Main from '@/views/Main.vue'

const routes = [
  { 
    path: '/',
    redirect: '/auth',
  },
  {
    path: '/auth',
    name: 'auth',
    meta: { layout: Auth },
    component: Auth
  },
  {
    path: '/main',
    name: 'main',
    meta: { layout: Base },
    component: Main
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/auth'
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const api = useApi();
  const token = api.getFromCookieAndDecodeToken();
  if (!to.redirectedFrom?.fullPath) {
    if (token) {
      next();
    } else {
      next({ name: 'auth' });
    }
  }
});

export default router
